export const BACKEND = {
    HOST : 'http://51.75.30.211:8080',
    //HOST: 'http://localhost:8080',
}